import React from 'react';
import { TaskStats } from '../types/Task';
import './StatsBar.css';

interface StatsBarProps {
  stats?: TaskStats;
}

const StatsBar: React.FC<StatsBarProps> = ({ stats }) => {
  if (!stats) return null;

  return (
    <div className="stats-bar-section">
      <div className="stats-bar-container">
        <div className="stat-item">
          <span className="stat-value">{stats.total}</span>
          <span className="stat-label">total</span>
        </div>
        
        {stats.columns
          .sort((a, b) => a.order - b.order)
          .map((column) => (
            <div key={column.id} className="stat-item">
              <span className="stat-value" style={{ color: column.color }}>
                {column.count}
              </span>
              <span className="stat-label">{column.title.toLowerCase()}</span>
            </div>
          ))}
        
        {stats.overdueCount > 0 && (
          <div className="stat-item overdue">
            <span className="stat-value">{stats.overdueCount}</span>
            <span className="stat-label">overdue</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default StatsBar; 